import React, { Component, Fragment } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import HelloSign from 'hellosign-embedded';

import {
  getCreateTemplateUrl, displayToaster, hideToaster, toggleDrawer,
  GET_CREATE_TEMPLATE_URL, GET_EDIT_TEMPLATE_URL, clearLoadingState, saveTemplateMetadata,
  LOADING_PROP_TYPE,
} from '../../../../modules/index';
import { Drawer, DrawerHeader, LockedModalBody, ExitConfirmationModal } from '../../../index';
import { APPLICATION_ROOT, ESIGN_DEV_MODE } from '../../../../constants/index';

const DEFAULT_STATE = {
  drawerClasses: ['drawer', 'wider'],
  helloSignClient: undefined,
  confirmationModalIsOpen: false,
};

class HellosignContainer extends Component {
  constructor(props) {
    super(props);
    this.state = DEFAULT_STATE;

    this.handleDrawer = this.handleDrawer.bind(this);
  }

  componentDidUpdate(prevProps) {
    const {
      templateData: {
        clientId,
        url,
        id,
      },
      resetTemplateState,
    } = this.props;
    const container = document.getElementById('template-container');
    let client;
    if (this.props.templateData.url && prevProps.templateData.url !== this.props.templateData.url) {
      client = new HelloSign({ clientId });
      client.open(
        url,
        { container, skipDomainVerification: ESIGN_DEV_MODE }
      );
    }
    if (client) {
      if (this.props.uploadTemplateValues) {
        client.on('createTemplate', () => {
          this.props.displayToaster([
            'success',
            <FormattedMessage id="TEMPLATE_CREATED" />,
            'app',
            5000,
            true,
          ]);

          const {
            file: droppedFile, uploadTemplateValues: { category, title },
          } = this.props;
          const { file: { name: fileName } } = droppedFile;
          this.props.saveTemplateMetadata({
            id, fileName, category, title,
          });
          client.close();
          this.handleDrawer();
          resetTemplateState();
        });
      } else {
        client.on('createTemplate', () => {
          this.props.displayToaster([
            'success',
            <FormattedMessage id="TEMPLATE_UPDATED" />,
            'app',
            5000,
            true,
          ]);
          this.handleDrawer();
          client.close();
        });
      }
      client.on('ready', () => {
        const { drawerClasses } = this.state;
        this.setState({
          drawerClasses: [...drawerClasses],
          helloSignClient: client,
        });
      });
    }
  }

  handleDrawer() {
    const { drawerIsOpen, toggleHelloSignDrawer } = this.props;
    const { helloSignClient } = this.state;

    if (helloSignClient && drawerIsOpen) helloSignClient.close();
    toggleHelloSignDrawer();
    this.props.toggleDrawer(false);
    this.props.hideToaster('drawer');
    this.props.clearLoadingState(GET_CREATE_TEMPLATE_URL);
    this.props.clearLoadingState(GET_EDIT_TEMPLATE_URL);
  }

  closeConfirmationModal(quitTemplateCreation) {
    this.setState({ confirmationModalIsOpen: false });
    if (quitTemplateCreation) {
      this.handleDrawer();
      this.props.resetTemplateState();
    }
  }

  render() {
    const {
      drawerClasses,
    } = this.state;
    const {
      loading,
      documentTitle,
      helloSignDrawerOpen,
    } = this.props;
    const isLoading =
        loading[GET_CREATE_TEMPLATE_URL] === 'loading' || loading[GET_EDIT_TEMPLATE_URL];
    const containerClasses = ['hello-sign-container', 'w-100', 'h-100'];
    if ((loading[GET_CREATE_TEMPLATE_URL] && loading[GET_CREATE_TEMPLATE_URL] !== 'error' && isLoading) ||
       (loading[GET_EDIT_TEMPLATE_URL] && loading[GET_EDIT_TEMPLATE_URL] !== 'error' && isLoading)) {
      containerClasses.push('loading');
    }
    return (
      <Fragment>
        <ExitConfirmationModal
          title="QUIT_EDITING"
          message="YOUR_CHANGES_WONT_BE_SAVED_AMBIGUOUS"
          closeConfirmationModal={quitTemplateCreation => this.closeConfirmationModal(quitTemplateCreation)}
          confirmationModalIsOpen={this.state.confirmationModalIsOpen}
        />
        <Drawer
          modalClassName={drawerClasses.join(' ')}
          toggle={() => {}}
          isOpen={helloSignDrawerOpen}
          parentselector={APPLICATION_ROOT}
          backdrop={loading[GET_CREATE_TEMPLATE_URL] === 'loading' || loading[GET_EDIT_TEMPLATE_URL] === 'loading' ? 'static' : true}
        >
          <DrawerHeader
            title={documentTitle || 'ADD_DOCUMENT'}
            useFormattedMessage={this.props.uploadTemplateValues}
            toggle={() => this.setState({ confirmationModalIsOpen: true })}
          />
          <LockedModalBody className="p-4 h-100">
            {loading[GET_EDIT_TEMPLATE_URL] === 'loading' || loading[GET_CREATE_TEMPLATE_URL] === 'loading' ?
              <div id="template-container" className={`d-flex ${containerClasses.join(' ')}`}>
                <div className="align-self-center justify-content-center mx-auto pb-5">
                  <FormattedMessage id="DOCUMENT_LOADING_PLEASE_WAIT" />
                </div>
              </div>
              :
              <div id="template-container" className={containerClasses.join(' ')} />
            }
          </LockedModalBody>
        </Drawer>
      </Fragment>
    );
  }
}

HellosignContainer.defaultProps = {
  drawerIsOpen: false,
  uploadTemplateValues: null,
  file: null,
  documentTitle: null,
};

HellosignContainer.propTypes = {
  templateData: PropTypes.shape({
    clientId: PropTypes.string,
    url: PropTypes.string,
    id: PropTypes.string,
  }).isRequired,
  documentTitle: PropTypes.string,
  displayToaster: PropTypes.func.isRequired,
  loading: LOADING_PROP_TYPE.isRequired,
  drawerIsOpen: PropTypes.bool,
  toggleDrawer: PropTypes.func.isRequired,
  toggleHelloSignDrawer: PropTypes.func.isRequired,
  helloSignDrawerOpen: PropTypes.bool.isRequired,
  hideToaster: PropTypes.func.isRequired,
  clearLoadingState: PropTypes.func.isRequired,
  saveTemplateMetadata: PropTypes.func.isRequired,
  resetTemplateState: PropTypes.func.isRequired,
  uploadTemplateValues: PropTypes.shape({
    category: PropTypes.string,
    title: PropTypes.string,
  }),
  file: PropTypes.shape({
    file: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
};

export default connect(
  (state) => {
    const { resources: { companies }, appState } = state;
    return {
      companies,
      loading: appState.loading,
      drawerIsOpen: appState.drawer.isOpen,
    };
  },
  {
    getCreateTemplateUrl: (file, companyId, category, title) => getCreateTemplateUrl(file, companyId, category, title),
    displayToaster: args => displayToaster(...args),
    toggleDrawer: open => toggleDrawer(open),
    hideToaster: location => hideToaster(location),
    clearLoadingState: action => clearLoadingState(action),
    saveTemplateMetadata: postBody => saveTemplateMetadata(postBody),
  }
)(hot(module)(HellosignContainer));



// WEBPACK FOOTER //
// ./src/components/Forms/CreateTemplate/HelloSignContainer/HellosignContainer.jsx